// Who may edit a Note of Presentation / Report, and at which workflow step.
//
// Extracted from np-editor so anything else that writes to a note through
// saveEditNp — notably the AI panel's "Save corrections" — gates on exactly
// the same rule. A second, drifting copy of this logic would let one surface
// save changes another would refuse, which is the kind of divergence nobody
// notices until a note is edited at the wrong step.
//
// The editor remains the authority on the *rule*; this file is that rule,
// moved somewhere both callers can reach.

import { isHorSovathana } from './user';

const mappingStep = { draft: 1, office: 2, department: 3, ddg: 4, assistant: 5, dg: 6, fsa: 7, done: 8 };

function canEditNp(detail, currentUser) {
	const step = mappingStep[detail?.step];
	const position = currentUser?.position;
	const role = currentUser?.role || '';
	const roles = role?.split(',');

	if (step === 1) return true; // Everybody in np/rp can edit at draft 04/03/2026

	if (roles?.includes('assistant')) {
		return (
			[5, 7, 8]?.includes(step) ||
			(step === 1 && currentUser?.id === detail?.createdBy) ||
			(step === 2 && ['5', '6'].includes(position) && detail?.office === currentUser?.office && detail?.department === currentUser?.department) ||
			(step === 3 && ['3', '4'].includes(position) && detail?.department === currentUser?.department)
		);
	}

	if (step > 7) {
		return false;
	}

	if (roles?.includes('admin')) {
		return true;
	}

	if (isHorSovathana(currentUser)) {
		return step === 4 || (step === 1 && currentUser?.id === detail?.createdBy);
	}

	if (['7', '8']?.includes(position)) {
		return step === 1;
	}
	if (['6', '5']?.includes(position)) {
		return step === 2 || (step === 1 && currentUser?.id === detail?.createdBy);
	}
	if (['4', '3']?.includes(position)) {
		return step === 3 || (step === 1 && currentUser?.id === detail?.createdBy);
	}
	if (['2']?.includes(position)) {
		return step === 4 || (step === 1 && currentUser?.id === detail?.createdBy);
	}
	if (['1']?.includes(position)) {
		return step === 6 || (step === 1 && currentUser?.id === detail?.createdBy);
	}

	return false;
}

export { canEditNp, mappingStep };
